export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_06.cefc7d37.jpg";